import axios from 'axios'
import { Message } from 'element-ui'

// 创建axios实例
axios.defaults.baseURL = process.env.VUE_APP_BASE_HOST
const service = axios.create({
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器 - 修复版本
service.interceptors.request.use(
  config => {
    // 开发环境下处理URL：移除api前缀，直接使用后端路径
    if (process.env.NODE_ENV === 'development') {
      // 如果URL以/api开头，移除/api前缀
      if (config.url && config.url.startsWith('/api/')) {
        config.url = config.url.replace('/api/', '/')
      } else if (config.url === '/api') {
        config.url = '/'
      }
    }
    
    // 添加时间戳防止缓存
    if (config.method === 'get') {
      config.params = {
        ...config.params,
      }
    }
    
    // 添加认证token
    const token = localStorage.getItem('token') || sessionStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    
    // 添加设备信息
	config.headers['clientId'] = 'e5cd7e4891bf95d1d19206ce24a7b32e'
    config.headers['X-Device-ID'] = process.env.VUE_APP_MACHINEID
    config.headers['X-Client-Host'] = process.env.VUE_APP_HOST
    
    console.log('请求配置:', {
      url: config.url,
      method: config.method,
      baseURL: config.baseURL,
      fullURL: config.baseURL + config.url, // 现在应该显示 http://192.168.3.211:8080/outpatient/login
      params: config.params,
      data: config.data
    })
    
    return config
  },
  error => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器（保持不变）
service.interceptors.response.use(
  response => {
    console.log('响应数据:', {
      url: response.config.url,
      data: response.data
    })
    
    if (response.data && typeof response.data === 'object') {
      if (response.data.code === 200 || response.data.success) {
        return response.data
      } else {
        Message.error(response.data.msg)
        return Promise.reject(new Error(response.data.msg))
      }
    }
    
    return response.data
  },
  error => {
    console.error('响应错误:', error)
    
    if (error.response) {
      const status = error.response.status
      const message = error.response.data?.message || `请求失败 (${status})`
      
      switch (status) {
        case 400:
          Message.error('请求参数错误')
          break
        case 401:
          Message.error('未授权，请重新登录')
          localStorage.removeItem('token')
          sessionStorage.removeItem('token')
          window.location.href = '/login'
          break
        case 403:
          Message.error('拒绝访问')
          break
        case 404:
          Message.error('请求地址不存在')
          break
        case 500:
          Message.error('服务器内部错误')
          break
        case 502:
          Message.error('网关错误')
          break
        case 503:
          Message.error('服务不可用')
          break
        case 504:
          Message.error('网关超时')
          break
        default:
          Message.error(message)
      }
    } else if (error.request) {
      if (error.message.includes('Network Error')) {
        Message.error('网络连接失败，请检查网络设置')
      } else if (error.code === 'ECONNABORTED') {
        Message.error('请求超时，请重试')
      } else {
        Message.error('网络异常，请检查网络连接')
      }
    } else {
      Message.error('请求配置错误')
    }
    
    return Promise.reject(error)
  }
)

export default service